import type { Question } from '@/api/types';

export function slotsFor(q: Question): number {
  return q.answer_type === 'team_ranking' ? (q.slot_count ?? 0) : 1;
}

export function optionLabel(q: Question, id: number | null | undefined): string {
  if (id == null) return '—';
  const opt = q.options?.find((o) => o.id === id);
  if (!opt) return `#${id}`;
  return opt.short_code?.trim() || opt.label;
}

/** Spaltenkopf einer Frage in der Tippübersicht: Admin-Kürzel, sonst F1/F2/... */
export function questionHeaderLabel(q: Question, index: number): string {
  return q.short_code?.trim() || `F${index + 1}`;
}

/** Formatiert die Lösung einer Frage (Team, mehrere Plätze bei team_ranking, oder Option). */
export function solutionLabel(
  q: Question,
  teamName: (id: number | null | undefined) => string,
): string {
  if (q.answer_type === 'team_ranking') {
    return Array.from({ length: slotsFor(q) }, (_, i) =>
      teamName(q.correct_ranking_team_ids?.[i]),
    ).join('·');
  }
  if (q.answer_type === 'multiple_choice') {
    const ids = q.correct_option_ids ?? [];
    return ids.length > 0 ? ids.map((id) => optionLabel(q, id)).join(' oder ') : '—';
  }
  return teamName(q.correct_team_id);
}

export interface QuestionAnswerLike {
  team_id?: number | null;
  ranking_team_ids?: (number | null)[];
  option_id?: number | null;
}

/** Formatiert eine Antwort (Team, mehrere Plätze bei team_ranking, oder Option). */
export function answerLabel(
  q: Question,
  answer: QuestionAnswerLike | undefined,
  teamName: (id: number | null | undefined) => string,
): string {
  if (!answer) return '—';
  if (q.answer_type === 'team_ranking') {
    return Array.from({ length: slotsFor(q) }, (_, i) =>
      teamName(answer.ranking_team_ids?.[i]),
    ).join('·');
  }
  if (q.answer_type === 'multiple_choice') {
    return optionLabel(q, answer.option_id);
  }
  return teamName(answer.team_id);
}
